const release2024 = [
  {
    date: '2024-12-16',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문상태변경 API 변경가능한 주문 상태 추가
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/orders/status',
            detail:
            <>
              - 배송완료로 변경 가능한 현재 주문상태에 <code>출고완료</code> 상태 추가<br/>
              - 판매완료로 변경 가능한 현재 주문상태에 <code>출고완료</code> 상태 추가
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2024-12-18',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 등록 API 파라미터 실결제금액 <code>pay_amt</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/order/add',
          }
        ]
      }
    ]
  },
  {
    date: '2024-12-04',
    items: [
      {
        type: 'Added',
        summary:
        <>
          수집 상품 삭제 API 추가
        </>,
        apis: [
          {
            method: 'DELETE',
            action: '/product/online/listOfScrap',
          }
        ]
      }
    ]
  },
  {
    date: '2024-11-12',
    items: [
      {
        type: 'Docs',
        summary:
        <>
          상품리스트 조회 v1.2 API 멀티 검색 입력값 설명 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/products/online/list/v1.2',
          }
        ]
      }
    ]
  },
  {
    date: '2024-10-22',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API, 선택작업 등록 API 스마트스토어 희망배송일 변경사항 적용
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWorkSelect',
            detail:
            <>
              - 희망배송일 변경 작업 추가
            </>
          },
          {
            method: 'POST',
            action: '/orders',
            detail: 
            <>
              - 주문 리스트 조회 시 주문 데이터에 스마트스토어 배송 속성 타입 <code>delivery_attribute_type</code> 추가
            </>
          }
        ]
      },
    ]
  },
  {
    date: '2024-09-25',
    items: [
      {
        type: 'Added',
        summary:
        <>
          중복의심주문 해제 API 추가
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/orders/suspicious/release',
          }
        ]
      },
      {
        type: 'Changed',
        summary:
        <>
          중복의심주문 여부/제외여부 플래그 추가 <br />
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWorkSelect',
            detail:
            <>
              - 선택작업 등록 API: 중복의심주문 제외여부 <code>dupl_doubt_except_yn</code> 추가
            </>
          },
          {
            method: 'PUT',
            action: '/order/instruction',
            detail:
            <>
              - 출고 지시 API: 중복의심주문 제외여부 <code>dupl_doubt_except_yn</code>  추가
            </>
          },
          {
            method: 'PUT',
            action: '/order/setInvoice',
            detail:
            <>
              - 배송정보 업데이트 API: 중복의심주문 제외여부 <code>dupl_doubt_except_yn</code> 추가
            </>
          },
          {
            method: 'PUT',
            action: '/order/setInvoice/v1.1',
            detail:
            <>
              - 배송정보 업데이트 API v1.1: 중복의심주문 제외여부 <code>dupl_doubt_except_yn</code> 추가
            </>
          },
          {
            method: 'POST',
            action: '/orders',
            detail:
            <>
              - 주문 리스트 조회 API: 응답에 중복의심주문 여부 <code>dupl_doubt_yn</code> 추가
            </>
          },
          {
            method: 'GET',
            action: '/order/:uniq',
            detail: 
            <>
              - 주문 상세 조회 API: 응답에 중복의심주문 여부 <code>dupl_doubt_yn</code> 추가
            </>
          },
        ]
      }
    ]
  },
  {
    date: '2024-09-23',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          수집 상품 리스트 조회 API 파라미터 JSON Body => Query Parameter로 변경
        </>,
        apis: [
          {
            method: 'GET',
            action: '/product/online/listOfScrap',
          }
        ]
      }
    ]
  },
  {
    date: '2024-09-13',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API 파라미터, Response 클레임 완료일 <code>claim_com_time</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
            detail: 
            <>
              - Body Parameter 날짜검색타입 클레임 완료일 <code>claim_com_time</code> 지원
              - Response 내 클레임 완료일 <code>claim_com_time</code> 추가
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2024-08-27',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API 파라미터 물류배송 주문 건 조회 여부 <code>fulfillment_yn</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          }
        ]
      }
    ]
  },
  {
    date: '2024-08-06',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          상품정보제공고시 <code>[상세설명참조]</code> 일괄 적용 파라미터 <code>is_desc_referred</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/products/add/v1.1',
          },
          {
            method: 'PUT',
            action: '/products/edit/v1.1',
          },
          {
            method: 'POST',
            action: '/stock/add/v1.2',
          },
          {
            method: 'PUT',
            action: '/stock/edit/v1.2',
          }
        ]
      },
    ]
  },
  {
    date: '2024-07-18',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          배송정보 업데이트 API 사용 가능 주문상태에 '배송중' 상태 추가
        </>,
        apis: [
          {
            method: 'PUT',
            action: '/order/setInvoice',
            detail:
            <>
              - <code>[출고대기, 출고보류, 운송장출력, 주문재확인, 배송중]</code> 상태 주문만 사용 가능
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2024-06-11',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          카테고리 조회 API 파라미터 분할 조회 파라미터 <code>start: 검색 시작값</code>, <code>length: 조회할 카테고리 갯수</code> 추가
        </>,
        apis: [
          {
            method: 'GET',
            action: '/categorys',
            detail:
            <>
              - 미입력시 전체 조회<br />
              - 비필수 값이지만 분할 조회 시에는 둘 다 입력
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2024-06-10',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          선택작업 등록 API 상품동기화 작업 등록 가능 상품 상태 제한
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWorkSelect',
            detail:
            <ul>
              - 상품동기화 작업 등록시 아래의 상태의 상품만 작업이 진행되도록 수정(해당하는 상품이 하나도 없는경우 작업등록 실패)<br />
              - <code>['승인대기', '판매중', '수정대기', '종료대기', '일시품절', '판매중지', '반려']</code>
            </ul>
          }
        ]
      }
    ]
  },
  {
    date: '2024-06-07',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          출고 지시 API 묶음번호 필수여부 변경 및 상태별 주문수량 조회 API 검색 파라미터 추가
        </>,
        apis: [
          {
            method: 'PUT',
            action: '/orders/instruction',
            detail:
            <>
              - 기존: 출고지시 처리시 bundle_codes 필수<br />
              - 변경: bundle_codes 비필수 <br />
              - bundle_codes 가 없는경우 sdate, edate 는 필수로 입력되어야 합니다. <br />
              - bundle_codes 가 입력된 경우 sdate, edate 값은 무시되고 bundle_codes 가 없는경우 sdate, edate 내의 신규주문건이 출고지시 처리됩니다.
            </>
          },
          {
            method: 'GET',
            action: '/orders/count',
            detail:
            <>
              - 상태별 주문수량 조회에 검색날짜 파라미터 추가 (미입력시 기본 한달로 조회)
            </>
          }
        ]
      },
    ]
  },
  {
    date: '2024-06-05',
    items: [
      {
        type: 'Added',
        summary:
        <>
          상태별 주문수량 조회 API 추가
        </>,
        apis: [
          {
            method: 'GET',
            action: '/orders/count',
          }
        ]
      }
    ]
  },
  {
    date: '2024-06-04',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          고객문의 조회 API search key 조회 항목 <code>inq_uniq : 문의고유번호</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/inquirys'
          }
        ]
      }
    ]
  },
  {
    date: '2024-05-21',
    items: [
      {
        type: 'Docs',
        summary:
        <>
          주문 리스트 조회 API 문서 Response 리스트 내 <code>multi_bundle_yn : 묶음주문여부</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          }
        ]
      }
    ]
  },
  {
    date: '2024-05-17',
    items: [
      {
        type: 'Changed',
        apis: [
          {
            method: 'POST',
            action: '/work/addWorkSelect',
            detail:
            <>
              선택작업 등록 결과에  <code>list</code> 항목 추가 <br />
              - 작업이 성공되는 경우에만 출력<br />
              - 주문작업인경우 list 값에 묶음번호 데이터가 출력됨
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2024-04-30',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문상태변경 API 변경 기준 uniq 기준 지원
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/orders/status',
            detail:
            <>
              - 기존: 묶음번호 기준으로 주문상태변경 가능<br />
              - 변경: uniq 기준 주문상태변경 가능 (uniq 주문상태가 [주문재확인]인 경우에만 변경 가능) <br />
              - 묶음번호, uniq 둘다 입력 시 uniq 주문 건만 상태 변경 (uniq 우선)
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2024-04-18',
    items: [
      {
        type: 'Fixed',
        summary:
        <>
          온라인상품 판매수량 수정 API 옵션 수량 수정 버그 수정
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/products/sale-cnt',
            detail:
            <>
              - 기존: 한 상품내 여러 옵션에 동일 sku 매칭 되어있는 경우 sku 처음 매칭된 옵션에만 수량 수정됨<br />
              - 수정: 한 상품내 여러 옵션에 동일 sku 매칭 되어있는 경우 sku 매칭된 모든 옵션에 수량 수정됨<br />
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2024-04-02',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          온라인상품 등록/수정 API 파라미터 <code>main_sku_cd</code> 추가 (대표SKU상품 설정 코드)
        </>,
        apis: [
          {
            method: 'PUT',
            action: '/products/edit/v1.1',
          },
          {
            method: 'POST',
            action: '/products/add/v1.1',
          }
        ]
      }, 
    ]
  },
  {
    date: '2024-03-13',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          선택작업 등록 API Response 결과 results 내 쇼핑몰 정보 노출 여부 <code>show_shop_info_yn</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWorkSelect',
          }
        ]
      }
    ]
  },
  {
    date: '2024-02-28',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문상태변경 API 파라미터 <code>status</code>에 허용 값 추가
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/orders/status',
            detail:
            <>
              - <strong>배송완료</strong> (현재 주문상태가 [주문재확인]인 경우에만 해당 값으로 변경 가능)<br/>
              - <strong>판매완료</strong> (현재 주문상태가 [주문재확인]인 경우에만 해당 값으로 변경 가능)<br/>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2024-02-26',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          SKU상품 리스트 조회 API Response 대표 배송처 번호 <code>main_depot_no</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stock/list/v1.2',
          }
        ]
      }
    ]
  },
  {
    date: '2024-02-22',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          SKU상품 리스트 조회 API Response 배송처, 옵션 정보 응답 형식 변경
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stock/list/v1.2',
          }
        ]
      }
    ]
  },
  {
    date: '2024-02-20',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          작업 등록 API Response 결과 results 내 쇼핑몰 정보 노출 여부 <code>show_shop_info_yn</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWork/v1.1',
          },
          {
            method: 'POST',
            action: '/work/addWork/v1.2',
          }
        ]
      }
    ]
  },
  {
    date: '2024-02-08',
    items: [
      {
        type: 'Added',
        summary:
        <>
          SKU상품 리스트 조회 API 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stock/list/v1.2',
          }
        ]
      }
    ]
  },
  {
    date: '2024-02-07',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          온라인상품 수정 API 파라미터 마스터 상품 연동 수정 여부 <code>edit_slave_all</code> 추가
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/products/edit/v1.1',
          }
        ]
      }
    ]
  },
  {
    date: '2024-01-26',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API, 주문 상세 조회 API 응답값에 원주문번호 <code>shop_ord_no_real</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/api/orders',
          },
          {
            method: 'GET',
            action: '/api/orders/:uniq',
          }
        ]
      }
    ]
  },
  {
    date: '2024-01-24',
    items: [
      {
        type: 'Docs',
        summary:
        <>
        주문 액션 내 파라미터, response 문서 설명 변경<br />
          - <code>창고 -> 배송처</code><br />
          - <code>재고코드 -> 재고관리코드</code>
        </>,
        apis: []
      }
    ]
  }
]

export default release2024;